import { type IRecentConversationsRepository } from '../../interfaces/IRecentConversationsRepository'

interface Dependency {
  recentConversationsRepository: IRecentConversationsRepository
}

export class RemoveRecentConversationUseCase {
  constructor(private readonly deps: Dependency) {}

  execute = (conversationId: string): void => {
    const remainingConversations = this.deps.recentConversationsRepository
      .getAll()
      .filter((conversation) => conversation.conversationId !== conversationId)

    this.deps.recentConversationsRepository.save(remainingConversations)
  }
}
